import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[lng]/components/news-components/news-detail-main-page/news-detail-main-page.tsx");
